import Bed from "@icons-rf/properties-item/bed.svg?react";
import Bath from "@icons-rf/properties-item/bath.svg?react";
import Card from "@icons-rf/properties-item/carro.svg?react";
import Casa2 from "@icons-rf/properties-item/casa2.svg?react";
import Medida from "@icons-rf/properties-item/medida.svg?react";
import Price1 from "@icons-rf/price-1.icon.svg?react";
import Level from "@icons-rf/properties-item/agua.svg?react";
import { CPropertyBuildingUnitFormKeys } from "@rf/property/module/components/property-form/util/schemas/building-form/building-unit.schema";
import { useWatch } from "react-hook-form";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useMemo } from "react";
import featureIndicators from "../../../../util/model/feature-indicators";
import { C_REALESTATE_TYPES_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";

const useFieldTable = () => {
  const property = useWatch({ name: CPropertyFormKeys.type_property });
  const id = property?.[0]?.id || 0;

  const items = useMemo(() => {
    return [
      {
        label: "ID",
        icon: null,
        show: true,
        field: "id",
        name: "-",
        maxWidth: 100
      },
      {
        label: "Nombre",
        icon: null,
        show: true,
        field: "input",
        name: CPropertyBuildingUnitFormKeys.name,
        maxWidth: 100
      },
      {
        label: "Habitación",
        icon: <Bed />,
        show: featureIndicators.projectBedrooms.includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.bedrooms,
        maxWidth: 100
      },
      {
        label: "Baños",
        icon: <Bath />,
        show: [
          C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
          C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
          C_REALESTATE_TYPES_PROJECT.HOUSE.id,
          C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
        ].includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.bathrooms,
        maxWidth: 100
      },
      {
        label: "½ Baño",
        icon: <Bath />,
        show: [
          C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
          C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
          C_REALESTATE_TYPES_PROJECT.HOUSE.id,
          C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
        ].includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.halfBathrooms,
        maxWidth: 100
      },
      {
        label: "Parqueos",
        icon: <Card />,
        show: featureIndicators.parkingSpots.includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.parkingSpots,
        maxWidth: 100
      },
      {
        label: "Nivel",
        icon: <Level />,
        show: featureIndicators.levelFloor.includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.levelFloor,
        maxWidth: 100
      },
      {
        label: "M² Solar.",
        icon: <Casa2 />,
        show: featureIndicators.projectMeterLand.includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.metersLand,
        maxWidth: 100
      },
      {
        label: "M² Const.",
        icon: <Medida />,
        show: featureIndicators.meterConstruction.includes(id || 0),
        field: "number",
        name: CPropertyBuildingUnitFormKeys.metersConstruction,
        maxWidth: 100
      },
      {
        label: "Moneda",
        icon: <Price1 />,
        show: true,
        field: "select",
        name: CPropertyBuildingUnitFormKeys.currency,
        maxWidth: 100
      },
      {
        label: "Precio de venta",
        icon: <Price1 />,
        show: true,
        field: "number",
        name: CPropertyBuildingUnitFormKeys.price,
        maxWidth: 100
      },
      {
        label: "||",
        icon: null,
        show: true,
        field: "opt",
        name: "-",
        maxWidth: 100
      }
    ];
  }, [id]);

  return items.filter(x => x.show) as {
    label: string;
    icon: JSX.Element;
    show: boolean;
    field: "input" | "select" | "number" | "id" | "opt";
    name: string;
  }[];
};

export default useFieldTable;
